import React, {useState} from 'react'
import MemberInfoModal from 'components/OurTeam/MemberInfoModal';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser'

export default function StaffTeam({data}) {

    const {staffTeamTitle, staffTeamBackgroundColor, staffTeamBlocks} = data;

    const [selectedTeamMember, setSelectedTeamMember] = useState(null);

    const handleOpen = block => setSelectedTeamMember(block);
    const handleClose = e => {
        if (e.target.classList.contains('modal')) setSelectedTeamMember(null);
    };
    return (
        <>
            <div id='staff' className={`executive-wrap panel-space-70 ${staffTeamBackgroundColor}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h2 className='heading-level-2 blue-color sm-text-center'>
                                {staffTeamTitle && parser(staffTeamTitle)}
                            </h2>
                        </div>
                    </div>
                    <div className='row team-row h-center'>
                        {staffTeamBlocks.map((block, i) => (
                            <div className='col-md-2 col-6 team-col' key={i}>
                                <figure className='team-profile-image'>
                                    <GatsbyImage
                                        image={getImage(block.staffTeamImage?.localFile)}
                                        alt='image'
                                    />
                                </figure>
                                <button
                                    className='team-name'
                                    type='button'
                                    data-bs-toggle='modal'
                                    data-bs-target='#stuff_description'
                                    onClick={() => handleOpen(block)}
                                    onKeyDown={() => handleOpen(block)}
                                >
                                    {block.staffTeamName}
                                </button>
                                <div className='team-position-text'>
                                    {block.staffTeamPosition}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <MemberInfoModal
                id='stuff_description'
                onClose={handleClose}
                image={selectedTeamMember?.staffTeamImage?.localFile}
                name={selectedTeamMember?.staffTeamName}
                position={selectedTeamMember?.staffTeamPosition}
                pronouns={selectedTeamMember?.staffTeamPronounce}
                linkedinLink={selectedTeamMember?.staffTeamLinkedinLink}
                facebookLink={selectedTeamMember?.staffTeamFacebookLink}
                email={selectedTeamMember?.staffTeamEmail}
                description={selectedTeamMember?.staffTeamDescription}
            />
        </>
    )
}
